const getTimeOptions = () => {
  const minutesInterval = 30;
  const times = [];
  let startTime = 0;

  for (let i = 0; startTime < 24 * 60; i++) {
    const hh = Math.floor(startTime / 60);
    const mm = startTime % 60;
    times[i] = `${`0${hh}`.slice(-2)}:${`0${mm}`.slice(-2)}`;
    startTime = startTime + minutesInterval;
  }

  const options = [...times.filter((time) => time !== '00:00'), '23:59'];
  return options.reverse();
};

export const timeOptions = getTimeOptions();
